import DatasetDetail from '../business360/DatasetDetail';

export default function Business360Dataset() {
  return <DatasetDetail />;
}
